module.exports = __webpack_public_path__ + "img/light.c3ae8d59.svg";